// Referral capture: associates share links like /package/goa-4d?ref=GCE-XXXXXX.
// The ref is stored for the session and a click is tracked once per ref per session.
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL ? `${process.env.REACT_APP_BACKEND_URL}/api` : "/api";
const KEY = "gc_ref";
const PATTERN = /^GC[EIAP]-[A-Z2-9]{6}$/;

export function captureReferral() {
    try {
        const ref = new URLSearchParams(window.location.search).get("ref");
        if (!ref) return;
        const code = ref.trim().toUpperCase();
        if (!PATTERN.test(code)) return;
        if (sessionStorage.getItem(KEY) === code) return; // already captured this session
        sessionStorage.setItem(KEY, code);
        axios.post(`${API}/associates/ref/click`, { ref: code }).catch(() => {});
    } catch { /* never break the page over referral tracking */ }
}

export function getReferral() {
    try {
        return sessionStorage.getItem(KEY) || "";
    } catch {
        return "";
    }
}
